module.exports = __webpack_public_path__ + "static/media/plus.1349d56e.svg";